import { useMutation } from '@tanstack/react-query';

import { customerPasswordService } from '@/services/customer/customer-password.service';
import type {
  CustomerPasswordChangeInput,
  CustomerPasswordChangeResponse,
  CustomerPasswordSetInput,
} from '@/types/customer-password';

export function useUpdateCustomerPassword() {
  return useMutation<CustomerPasswordChangeResponse, unknown, CustomerPasswordChangeInput>({
    mutationFn: (payload) => customerPasswordService.updatePassword(payload),
  });
}

export function useSetCustomerPassword() {
  return useMutation<CustomerPasswordChangeResponse, unknown, CustomerPasswordSetInput>({
    mutationFn: (payload) => customerPasswordService.setPassword(payload),
  });
}
